import { useEffect, useRef, useState } from 'react';
import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import './Consulta.css';
import { Panel } from 'primereact/panel';
import { Dropdown } from 'primereact/dropdown';
import FiltroPF from './filtro/FiltroPF';
import FiltroPJ from './filtro/FiltroPJ';
import { FilterWeb } from '../../interface/FilterWeb';
import postConsultaWebService from '../../service/postConsultaWeb/postConsultaWebService';
import Resposta from './Resposta';
import getCache from '../../service/getCache';
import {useNavigate } from 'react-router';
import { Messages } from 'primereact/messages';
import getUserCheck from '../../service/getUserCheck';
import { useGlobalState } from '../../components/globalState/GlobalStateProvider';
import FiltroAutomotiva from './filtro/FiltroAutomotiva';

export default function ConsultaPage() {
  const {state} = useGlobalState();
  const { t } = useTranslation();
  const [resposta, setResposta] = useState<any | null>(null);

  const [consultaCredito, setConsultaCredito] = useState(t('consultaCredito'));
  const navigate = useNavigate();
  const initialized = useRef(false)
  const msgs = useRef<Messages>(null);
  
  const handleCloseFilter = () => {
    setselectedTipoConsulta('pf');
    setResposta(null);
    navigate('/consultar')
  }

  const validIndicadores = (filterWeb:FilterWeb) : boolean => {
    let retorno = true;
    if(filterWeb.indicadores.length != 0){
      filterWeb.indicadores.map((item) => {
        if(item.target.length === 0){
            retorno= false;
        }
      })

    }
    return retorno;
  }

  const processResposta = (data:any, cache:boolean) => {
    if(data.separarResposta){
            
      if(data.scpc ||
        data.restricaoAvancadaScore ||
        data.restricaoSilver ||
        data.pendenciaFinanceira ||
        data.restricaoPalladium ||
        data.creditoScore ||
        data.protestoCentroProt ||
        data.pessoaCadastral ||
        data.pgfn ||
        data.pendenciaCompany ||
        data.receitaFederal ||
        data.pessoaCadastralStandard ||
        data.beneficioSocial ||
        data.renunciasBeneficios ||
        data.pessoaAssistenteSocial ||
        data.gps){
        const respostaEposi = {
          scpc: data.scpc,
          restricaoAvancadaScore: data.restricaoAvancadaScore,
          restricaoSilver: data.restricaoSilver,
          informativo: data.informativo,
          pendenciaFinanceira: data.pendenciaFinanceira,
          creditoScore: data.creditoScore,
          creditoScorePlus: data.creditoScorePlus,
          cadastralNomeCompleto: data.cadastralNomeCompleto,
          creditoPositivo: data.creditoPositivo,
          protestoCentroProt: data.protestoCentroProt,
          pessoaCadastral: data.pessoaCadastral,
          pessoaCadastralStandard: data.pessoaCadastralStandard,
          restricaoPalladium: data.restricaoPalladium,
          pgfn:  data.pgfn,
          gps:  data.gps,
          trt:  data.trt,
          tst:  data.tst,
          acoesCompleta: data.acoesCompleta,
          automotivaVeiculoProprietario: data.automotivaVeiculoProprietario,
          cadastralSrcBacenScorePositivo: data.cadastralSrcBacenScorePositivo,
          autoVistoria: data.autoVistoria,
          autoLeilaoVipGold: data.autoLeilaoVipGold,
          autoPlatinum: data.autoPlatinum,
          veiculoProprietario: data.veiculoProprietario,
          cadastralPlus: data.cadastralPlus,
          pendenciaCompany: data.pendenciaCompany,
          receitaFederal : data.receitaFederal,
          dividaAtiva: data.dividaAtiva,
          cadastralEmpresaCnpj: data.cadastralEmpresaCnpj,
          beneficioSocial: data.beneficioSocial,
          renunciasBeneficios: data.renunciasBeneficios,
          pessoaAssistenteSocial: data.pessoaAssistenteSocial,
          cartorioProtesto: data.cartorioProtesto,
          cartorioProtestoRegional: data.cartorioProtestoRegional,
          avisos: data.avisos
        }
        localStorage.setItem('respostaEposi', JSON.stringify(respostaEposi));
        data.scpc = null;
        data.gps = null;
        data.cartorioProtesto = null;
        data.cartorioProtestoRegional = null;
        data.restricaoAvancadaScore = null;
        data.restricaoSilver = null;
        data.pendenciaFinanceira = null;
        data.creditoScore = null;
        data.creditoScore = null;
        data.creditoScorePlus = null;
        data.cadastralNomeCompleto = null;
        data.creditoPositivo = null;
        data.protestoCentroProt = null;
        data.acoesCompleta = null;
        data.pessoaCadastral = null;
        data.pessoaCadastralStandard = null;
        data.restricaoPalladium = null;
        data.pgfn = null;
        data.veiculoProprietario = null;
        data.cadastralPlus = null;
        data.cadastralEmpresaCnpj = null;
        data.autoVistoria = null;
        data.autoLeilaoVipGold = null;
        data.autoPlatinum = null;
        data.trt = null;
        data.tst = null;
        data.dividaAtiva = null;
        data.cadastralSrcBacenScorePositivo = null;
        data.pendenciaCompany = null;
        data.receitaFederal = null;
        data.automotivaVeiculoProprietario = null;
        data.beneficioSocial = null;
        data.renunciasBeneficios = null;
        data.pessoaAssistenteSocial = null;
        if(cache){
          window.open('./eposi','_blank')
        }
        else{
          window.open('consultar/eposi','_blank')
        }
        
      }
      if(data.dadosConsulta || 
        data.dadosConsultaPJ || 
        data.score ||
        data.scoreBoletoPJ ||
        data.acoes ||
        data.showApontamento || 
        (data.protestosQuod && data.protestosQuod.length > 0) ||
        (data.ccfs && data.ccfs.length > 0) ||
        data.rendaPresumida ||
        data.scoreGrauAtividadePJ ||
        data.comportamentoFinanceiro ||
        data.gastoEstimadoPJ ||
        data.linhaCredito ||
        data.autenticacoesCartao ||
        data.quodAutenticaCadastral ||
        data.pontualidadePagamento ||
        data.historicoPagamento ||
        (data.endividamentos && data.endividamentos.length > 0) ||
        data.historicoVencido ||
        data.limiteCreditoPJ ||
        data.maisNegocio ||
        data.faturamentosPresumido ||
        data.consulta ||
        data.scoreInadimplenciaPJ ||
        (data.empresas && data.empresas.length > 0) ||
        (data.socios && data.socios.length > 0) ||
        (data.participacoesEmpresa && data.participacoesEmpresa.length > 0) ||
        (data.enderecosHist && data.enderecosHist.length > 0) ||
        (data.emailsHist && data.emailsHist.length > 0) ||
        (data.conglomerados && data.conglomerados.length > 0) ||
        (data.calularesHist && data.calularesHist.length > 0) ||
        (data.telefonesHist && data.telefonesHist.length > 0) ||
        (data.analises && data.analises.length > 0) ||
        (data.indicadoresPJ && data.indicadoresPJ.length > 0) ||
        (data.indicadores && data.indicadores.length > 0)
        ){
        localStorage.setItem('resposta', JSON.stringify(data));
        if(cache){
          window.open('./quod','_blank')
        }
        else{
          window.open('consultar/quod','_blank')
        }
      }
    }
    else{
      setResposta(data);
    }
  }

  const handleProcessFilter = (filterWeb:FilterWeb, automotiva:boolean) => {
    msgs.current?.clear();
    // Validação: impedir operação quando o cliente estiver inativo
    if (state.user?.cliente?.inativo === true) {
      window.scrollTo(0, 0);
      msgs.current?.clear();
      msgs.current?.show([
        { sticky: false, life: 10000, severity: 'warn', summary: 'Atenção', detail: 'Cliente inativo. Não é possível realizar esta operação. Entre em contato com o suporte.', closable: false }
      ]);
      return;
    }
    if(filterWeb.consultas.length > 0 && (filterWeb.consultas.includes('QUODVERIFIQPJ_MAISNEGOCIO') || filterWeb.consultas.includes('QUODMAISNEGOCIOPJ')) && ( !filterWeb.valor || filterWeb.valor < 1 || (!filterWeb.arrojado && !filterWeb.usual && !filterWeb.conservador)  )){
      window.scrollTo(0, 0);
      msgs.current?.clear();
        msgs.current?.show([
            { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: 'O valor e o perfil de risco são obrigatórios', closable: false }
          
        ]);
    }
    else{
      if(!validIndicadores(filterWeb)){
        window.scrollTo(0, 0);
        msgs.current?.clear();
          msgs.current?.show([
              { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: 'Indicadores não Selecionados', closable: false }
            
          ]);

      }
      else{
        if(automotiva || (filterWeb.documento && filterWeb.consultas && filterWeb.consultas.length > 0)){
          if(filterWeb.indicadores){
            const indicadores :any[] = []
            filterWeb.indicadores.map((item:any) => {item.target.map((i:any) => indicadores.push(i.value))})
            filterWeb.indicadores = indicadores;
          }
          const findLabel = (consultas: Array<any>, value: string): string => {
            for (const consulta of consultas) {
                if (consulta.value === value) {
                    return consulta.label;
                }
                if (consulta.permissoes && consulta.permissoes.length > 0) {
                    const foundLabel = findLabel(consulta.permissoes, value);
                    if (foundLabel !== value) {
                        return foundLabel;
                    }
                }
            }
            return value;
        };
        const consultasLabels = filterWeb.consultas.map(consultaKey => findLabel(state.user.consultas, consultaKey));
        setConsultaCredito(`${t('consultaCredito')} - ${consultasLabels.join(', ')}`);
          postConsultaWebService(filterWeb)
          .then((data) => {
            window.scrollTo(0, 0);
            processResposta(data, false);
            setselectedTipoConsulta('pf');
          })
          .catch((error) => {
            const dataError = new String(error)
            window.scrollTo(0, 0);
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: "Erro ao realizar consulta " + (dataError && dataError.startsWith('Error: Cliente') ? (' - ' + dataError.split('Error:')[1]) : ''), closable: false }
              
            ]);
          })
          .finally(() => window.dispatchEvent(new Event("degustacaoAtualizar")))
        }
        else{
          window.scrollTo(0, 0);
          msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: 'Documento e opção de consulta são obrigatórios', closable: false }
              
            ]);
        }
      }
    }
    
    
           
    
  }
  const [selectedTipoConsulta, setselectedTipoConsulta] = useState('pf');
    const tiposConsulta = [
        { name: 'Selecione', code: null },
        { name: 'Consulta Pessoa Física', code: 'pf' },
        { name: 'Consulta Pessoa Jurídica', code: 'pj' },
        { name: "Consulta Automotiva", code: "auto" }
    ];

    const findCacheById = (id:string) => {
      if(id && !id.includes('consultar') && !id.includes('quod') && !id.includes('eposi')){
       
        getCache(id).then(data => {window.scrollTo(0, 0);
          processResposta(data, true);});
        }
      }
   

    useEffect(() => {
      getUserCheck().then((response) => console.log(response))
      if (!initialized.current) {
        initialized.current = true
        const path = window.location.href.split('/')[window.location.href.split('/').length-1];
        if(path === 'eposi'){
          const resp = localStorage.getItem('respostaEposi')
          if(resp){
            localStorage.removeItem('respostaEposi')
            setResposta(JSON.parse(resp))
          }
        }
        else{
          const resp = localStorage.getItem('resposta')
          if(resp){
            localStorage.removeItem('resposta')
            setResposta(JSON.parse(resp))
          }
        }
        findCacheById(path);
      }
    },[])
  
  
  return (
    <Container>
      <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 className="h3 mb-0 text-gray">
                <i className="pi pi-search-plus" style={{ fontSize: '2.0rem' }}></i> 
                  {consultaCredito}
                </h1>
            </div>     
          </div>
      </div>
      
      <div className="row">
        <div className='col-lg-6 mb-3' style={{width:'60%'}}>
          <Messages ref={msgs} />
          {resposta == null && (
            <Panel header={t('opcaoConsulta')}>
              <Dropdown value={selectedTipoConsulta} onChange={(e) => setselectedTipoConsulta(e.value)} options={tiposConsulta} optionLabel="name" 
                    placeholder="Selecione o tipo Consulta" optionValue='code' className="w-full md:w-14rem" />
            </Panel>
          )}
          <br></br>
          {selectedTipoConsulta === 'pf' && resposta == null && (
            <FiltroPF msgs={msgs} onProcess={handleProcessFilter} onClose={handleCloseFilter}></FiltroPF>
          )}

          {selectedTipoConsulta === 'pj' && resposta == null && (
            <FiltroPJ msgs={msgs} onProcess={handleProcessFilter}  onClose={handleCloseFilter}></FiltroPJ>
          )}
          
          {selectedTipoConsulta === "auto" && resposta == null && (
            <FiltroAutomotiva
              onProcess={handleProcessFilter}
              onClose={handleCloseFilter}
            ></FiltroAutomotiva>
          )}
         
         
        </div>
      </div>
      <div>
        {resposta != null && (
              <Resposta original={!resposta.informativo.hideQuod} resposta={resposta} onClose={handleCloseFilter}></Resposta>
            )}
      </div>       
           
                
    </Container>
  )
}
